import { render, staticRenderFns } from "./new_rubric_view.vue?vue&type=template&id=06c714d6&scoped=true&"
import script from "./new_rubric_view.vue?vue&type=script&lang=js&"
export * from "./new_rubric_view.vue?vue&type=script&lang=js&"
import style0 from "./new_rubric_view.vue?vue&type=style&index=0&id=06c714d6&prod&scoped=true&lang=scss&"
import style1 from "./new_rubric_view.vue?vue&type=style&index=1&id=06c714d6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c714d6",
  null
  
)

export default component.exports